/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */

document.addEventListener( 'DOMContentLoaded', () => {
	$( 'a[href="#top"]' ).on( 'click', function ( event ) {
		event.preventDefault();

		$( 'html, body' ).animate( {
			scrollTop: 0,
		} );
	} );
} );
